import React from 'react'
import css from './style.scss'

export default (props)=>{
  return (
    <div className={css.infoContainer}>
      <div className={css.info}>
        <h2>{props.name || "Loading..."}</h2>
        <p>{(props.info ? props.info.bio : "")}</p>
      </div>
      <img alt="" className={css.profileImage} src={props.picture}/>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/account_page/account_info/index.js